var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.localModel,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "50%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.localModel = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "tools",
        fn: function () {
          return [
            _c(
              "v-tooltip",
              {
                attrs: { bottom: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-menu",
                          _vm._g(
                            _vm._b(
                              {
                                attrs: {
                                  "offset-x": "",
                                  "offset-y": "",
                                  bottom: "",
                                  "close-on-content-click": false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({
                                        on: onMenu,
                                        attrs: attrsMenu,
                                      }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    fab: "",
                                                    color: "primary",
                                                    "x-small": "",
                                                  },
                                                },
                                                "v-btn",
                                                attrsMenu,
                                                false
                                              ),
                                              { ...on, ...onMenu }
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("mdi-tag-plus-outline")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.viewMenu,
                                  callback: function ($$v) {
                                    _vm.viewMenu = $$v
                                  },
                                  expression: "viewMenu",
                                },
                              },
                              "v-menu",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(
                              "v-list",
                              { staticClass: "py-0", attrs: { dense: "" } },
                              [
                                _c(
                                  "v-subheader",
                                  { staticClass: "caption font-weight-bold" },
                                  [_vm._v("Conteúdo do termo")]
                                ),
                                _c(
                                  "emc-util-scroll",
                                  { attrs: { maxHeight: "200px" } },
                                  _vm._l(_vm.tags, function (tag, i) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: "content-" + i,
                                        attrs: { link: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setField(tag)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              { staticClass: "text-body-2" },
                                              [_vm._v(_vm._s(tag.tag))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                                _vm.localModel && _vm.localModel.send_email
                                  ? _c("v-divider")
                                  : _vm._e(),
                                _vm.localModel && _vm.localModel.send_email
                                  ? _c(
                                      "v-subheader",
                                      {
                                        staticClass: "caption font-weight-bold",
                                      },
                                      [_vm._v("Corpo do e-mail")]
                                    )
                                  : _vm._e(),
                                _vm.localModel && _vm.localModel.send_email
                                  ? _vm._l(_vm.emailTags, function (tag, i) {
                                      return _c(
                                        "v-list-item",
                                        {
                                          key: "email-" + i,
                                          attrs: { link: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setEmailField(tag)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                { staticClass: "text-body-2" },
                                                [_vm._v(_vm._s(tag.tag))]
                                              ),
                                              _c(
                                                "v-list-item-subtitle",
                                                { staticClass: "caption" },
                                                [
                                                  _vm._v(
                                                    _vm._s(tag.description)
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    })
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              },
              [_c("span", [_vm._v("Inserir tag — Ctrl+Shift+T")])]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-3 rounded mb-1",
                            attrs: { flat: "", outlined: "" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center flex-wrap" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "subtitle-2 grey--text text--darken-1 mr-4",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("mdi-file-document-edit-outline")]
                                    ),
                                    _vm._v(" Tipo de Documento "),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-btn-toggle",
                                  {
                                    attrs: {
                                      mandatory: "",
                                      dense: "",
                                      color: "#1A73E8",
                                    },
                                    model: {
                                      value: _vm.localModel.content_source,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localModel,
                                          "content_source",
                                          $$v
                                        )
                                      },
                                      expression: "localModel.content_source",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      { attrs: { value: "static", small: "" } },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", left: "" } },
                                          [_vm._v("mdi-text")]
                                        ),
                                        _vm._v(" Texto Livre "),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      { attrs: { value: "pit", small: "" } },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", left: "" } },
                                          [_vm._v("mdi-flash")]
                                        ),
                                        _vm._v(" Modelo Dinâmico (PIT) "),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.isPit
                              ? _c(
                                  "div",
                                  { staticClass: "caption grey--text mt-2" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          "x-small": "",
                                          color: "amber darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-flash")]
                                    ),
                                    _vm._v(
                                      " Conteúdo gerado automaticamente a partir do Extrato do Professor. "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "8" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            autofocus: "",
                            label: "Nome*",
                            error: !!_vm.errors.name,
                            "error-messages": _vm.errors.name,
                            counter: 255,
                          },
                          model: {
                            value: _vm.localModel.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "name", $$v)
                            },
                            expression: "localModel.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            code: "",
                            "error-messages": _vm.errors.code,
                            label: "Código",
                          },
                          model: {
                            value: _vm.localModel.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "code", $$v)
                            },
                            expression: "localModel.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            label: "Descrição*",
                            error: !!_vm.errors.description,
                            "error-messages": _vm.errors.description,
                            counter: 255,
                            rows: "2",
                            outlined: "",
                          },
                          model: {
                            value: _vm.localModel.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "description", $$v)
                            },
                            expression: "localModel.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("v-divider", { staticClass: "my-3" }),
                        _c(
                          "v-card",
                          {
                            staticClass: "grey lighten-5 pa-3 rounded",
                            attrs: { flat: "" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-center justify-space-between mb-3",
                              },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "subtitle-1 font-weight-medium",
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { color: "primary" },
                                        },
                                        [_vm._v("mdi-format-list-checks")]
                                      ),
                                      _vm._v(" Opções de Resposta "),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "caption grey--text mt-1" },
                                    [
                                      _vm._v(
                                        " Defina as opções que o usuário poderá escolher ao responder este termo "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      small: "",
                                      color: "#1A73E8",
                                      dark: "",
                                    },
                                    on: { click: _vm.addTermOption },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", left: "" } },
                                      [_vm._v("mdi-plus")]
                                    ),
                                    _vm._v(" Nova Opção "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._l(
                              _vm.localModel.term_options,
                              function (option, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "mb-2" },
                                  [
                                    _c(
                                      "v-card",
                                      {
                                        staticClass: "pa-3",
                                        class: _vm.getOptionCardClass(option),
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            attrs: {
                                              "no-gutters": "",
                                              align: "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mr-3",
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _c(
                                                  "v-avatar",
                                                  {
                                                    staticClass:
                                                      "white--text caption font-weight-bold",
                                                    attrs: {
                                                      size: "28",
                                                      color:
                                                        _vm.getOptionAvatarColor(
                                                          option
                                                        ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(index + 1) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "pr-2",
                                                attrs: { cols: "12", sm: "5" },
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: "Texto da opção",
                                                    placeholder:
                                                      "Ex: Li e concordo com os termos",
                                                    "persistent-placeholder":
                                                      "",
                                                    dense: "",
                                                    outlined: "",
                                                    "hide-details": "auto",
                                                    rules: [
                                                      (v) =>
                                                        !!v || "Obrigatório",
                                                    ],
                                                    error:
                                                      !!_vm.errors[
                                                        "term_options." +
                                                          index +
                                                          ".label"
                                                      ],
                                                    "error-messages":
                                                      _vm.errors[
                                                        "term_options." +
                                                          index +
                                                          ".label"
                                                      ],
                                                  },
                                                  model: {
                                                    value: option.label,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        option,
                                                        "label",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "option.label",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "d-flex align-center flex-wrap",
                                                attrs: { cols: "12", sm: "" },
                                              },
                                              [
                                                _c(
                                                  "v-btn-toggle",
                                                  {
                                                    staticClass: "mr-3 mb-1",
                                                    attrs: {
                                                      mandatory: "",
                                                      dense: "",
                                                    },
                                                    model: {
                                                      value:
                                                        option.acceptance_type,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          option,
                                                          "acceptance_type",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "option.acceptance_type",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: { bottom: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-btn",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "x-small":
                                                                                "",
                                                                              color:
                                                                                option.acceptance_type ===
                                                                                "accept"
                                                                                  ? "teal"
                                                                                  : "",
                                                                              dark:
                                                                                option.acceptance_type ===
                                                                                "accept",
                                                                              value:
                                                                                "accept",
                                                                            },
                                                                        },
                                                                        "v-btn",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "x-small":
                                                                                "",
                                                                              left: "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-check-circle"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " Aceite "
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            'Representa concordância (status "Assinado")'
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: { bottom: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-btn",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "x-small":
                                                                                "",
                                                                              color:
                                                                                option.acceptance_type ===
                                                                                "reject"
                                                                                  ? "blue-grey darken-1"
                                                                                  : "",
                                                                              dark:
                                                                                option.acceptance_type ===
                                                                                "reject",
                                                                              value:
                                                                                "reject",
                                                                            },
                                                                        },
                                                                        "v-btn",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "x-small":
                                                                                "",
                                                                              left: "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-close-circle"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " Não Aceite "
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            'Representa recusa (status "Recusado")'
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                            attrs,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-chip",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      staticClass:
                                                                        "mr-2 mb-1",
                                                                      attrs: {
                                                                        color:
                                                                          option.require_justification
                                                                            ? "amber darken-2"
                                                                            : "grey lighten-3",
                                                                        "text-color":
                                                                          option.require_justification
                                                                            ? "white"
                                                                            : "grey darken-1",
                                                                        small:
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            option.require_justification =
                                                                              !option.require_justification
                                                                          },
                                                                      },
                                                                    },
                                                                    "v-chip",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        "x-small":
                                                                          "",
                                                                        left: "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          option.require_justification
                                                                            ? "mdi-text-box-check"
                                                                            : "mdi-text-box-outline"
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    " Justificativa "
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _c("strong", [
                                                        _vm._v(
                                                          "Exigir Justificativa:"
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        " Quando ativado, o usuário"
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        " deverá informar o motivo ao selecionar esta opção "
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "auto" } },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                            attrs,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      attrs: {
                                                                        icon: "",
                                                                        small:
                                                                          "",
                                                                        disabled:
                                                                          _vm
                                                                            .localModel
                                                                            .term_options
                                                                            .length <=
                                                                          1,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.removeTermOption(
                                                                              index
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    "v-btn",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                        color:
                                                                          _vm
                                                                            .localModel
                                                                            .term_options
                                                                            .length <=
                                                                          1
                                                                            ? "grey lighten-1"
                                                                            : "error",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-delete-outline"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "Remover esta opção"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            _vm.localModel.term_options &&
                            _vm.localModel.term_options.length > 0 &&
                            !_vm.hasValidAcceptanceOption
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "ma-0 mt-2",
                                    attrs: {
                                      type: "info",
                                      dense: "",
                                      text: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          small: "",
                                          left: "",
                                          color: "info",
                                        },
                                      },
                                      [_vm._v("mdi-information")]
                                    ),
                                    _c("strong", [_vm._v("Dica:")]),
                                    _vm._v(
                                      ' Defina pelo menos uma opção como "Aceite" para identificar qual resposta representa concordância. '
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-3 d-flex align-center flex-wrap",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "caption grey--text mr-3" },
                                  [_vm._v("Legenda:")]
                                ),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      "x-small": "",
                                      color: "teal",
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { "x-small": "", left: "" } },
                                      [_vm._v("mdi-check-circle")]
                                    ),
                                    _vm._v(" Aceite "),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "caption grey--text text--darken-1 mr-3",
                                  },
                                  [_vm._v("= Concordância")]
                                ),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      "x-small": "",
                                      color: "blue-grey darken-1",
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { "x-small": "", left: "" } },
                                      [_vm._v("mdi-close-circle")]
                                    ),
                                    _vm._v(" Não Aceite "),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "caption grey--text text--darken-1 mr-3",
                                  },
                                  [_vm._v("= Recusa")]
                                ),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      "x-small": "",
                                      color: "amber darken-2",
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { "x-small": "", left: "" } },
                                      [_vm._v("mdi-text-box-check")]
                                    ),
                                    _vm._v(" Justificativa "),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "caption grey--text text--darken-1",
                                  },
                                  [_vm._v("= Exige motivo/explicação")]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("v-divider", { staticClass: "my-3" }),
                        _c(
                          "v-card",
                          {
                            staticClass: "grey lighten-5 pa-3 rounded",
                            attrs: { flat: "" },
                          },
                          [
                            _c("div", { staticClass: "mb-2" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "subtitle-1 font-weight-medium",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { color: "primary" },
                                    },
                                    [_vm._v("mdi-account-multiple-check")]
                                  ),
                                  _vm._v(" Configuração de Assinantes "),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "caption grey--text mt-1" },
                                [_vm._v("Quem assina este documento")]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-wrap align-center mb-2",
                              },
                              [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      color: "primary",
                                      outlined: "",
                                      small: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", left: "" } },
                                      [_vm._v("mdi-account")]
                                    ),
                                    _vm._v(" Assinante 1: Docente "),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", "max-width": "320" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-chip",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.localModel
                                                        .manager_signer_enabled
                                                        ? "primary"
                                                        : "grey",
                                                      outlined:
                                                        !_vm.localModel
                                                          .manager_signer_enabled,
                                                      dark: !!_vm.localModel
                                                        .manager_signer_enabled,
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.toggleManagerSigner,
                                                    },
                                                  },
                                                  "v-chip",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      left: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.localModel
                                                          .manager_signer_enabled
                                                          ? "mdi-checkbox-marked-circle"
                                                          : "mdi-checkbox-blank-circle-outline"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " Assinatura do Gestor do Docente "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "O gestor é buscado automaticamente no vínculo docente-gestor vigente (ativo e dentro da data de vigência) no momento do envio. Docentes sem gestor vigente não recebem o termo."
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._l(
                              _vm.localModel.additional_signatures,
                              function (signer, index) {
                                return _c(
                                  "v-card",
                                  {
                                    key: index,
                                    staticClass: "pa-3 mt-2",
                                    attrs: { outlined: "" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between mb-2",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subtitle-2" },
                                          [
                                            _vm._v(
                                              "Assinante " + _vm._s(index + 2)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeAdditionalSignature(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color: "error",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-delete-outline"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("Remover assinante"),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Rótulo do Cargo*",
                                                placeholder: "Ex: Coordenador",
                                                "persistent-placeholder": "",
                                                dense: "",
                                                outlined: "",
                                                "hide-details": "auto",
                                                error:
                                                  !!_vm.errors[
                                                    "additional_signatures." +
                                                      index +
                                                      ".label"
                                                  ],
                                                "error-messages":
                                                  _vm.errors[
                                                    "additional_signatures." +
                                                      index +
                                                      ".label"
                                                  ],
                                              },
                                              model: {
                                                value: signer.label,
                                                callback: function ($$v) {
                                                  _vm.$set(signer, "label", $$v)
                                                },
                                                expression: "signer.label",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Nome*",
                                                placeholder:
                                                  "Nome do assinante",
                                                "persistent-placeholder": "",
                                                dense: "",
                                                outlined: "",
                                                "hide-details": "auto",
                                                error:
                                                  !!_vm.errors[
                                                    "additional_signatures." +
                                                      index +
                                                      ".name"
                                                  ],
                                                "error-messages":
                                                  _vm.errors[
                                                    "additional_signatures." +
                                                      index +
                                                      ".name"
                                                  ],
                                              },
                                              model: {
                                                value: signer.name,
                                                callback: function ($$v) {
                                                  _vm.$set(signer, "name", $$v)
                                                },
                                                expression: "signer.name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "E-mail*",
                                                type: "email",
                                                placeholder:
                                                  "email@exemplo.com",
                                                "persistent-placeholder": "",
                                                dense: "",
                                                outlined: "",
                                                "hide-details": "auto",
                                                error:
                                                  !!_vm.errors[
                                                    "additional_signatures." +
                                                      index +
                                                      ".email"
                                                  ],
                                                "error-messages":
                                                  _vm.errors[
                                                    "additional_signatures." +
                                                      index +
                                                      ".email"
                                                  ],
                                              },
                                              model: {
                                                value: signer.email,
                                                callback: function ($$v) {
                                                  _vm.$set(signer, "email", $$v)
                                                },
                                                expression: "signer.email",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "CPF*",
                                                placeholder: "Somente números",
                                                "persistent-placeholder": "",
                                                dense: "",
                                                outlined: "",
                                                "hide-details": "auto",
                                                error:
                                                  !!_vm.errors[
                                                    "additional_signatures." +
                                                      index +
                                                      ".signer_document"
                                                  ],
                                                "error-messages":
                                                  _vm.errors[
                                                    "additional_signatures." +
                                                      index +
                                                      ".signer_document"
                                                  ],
                                              },
                                              model: {
                                                value: signer.signer_document,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    signer,
                                                    "signer_document",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "signer.signer_document",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "px-2 mt-2",
                                attrs: {
                                  small: "",
                                  color: "#1A73E8",
                                  text: "",
                                },
                                on: { click: _vm.addAdditionalSignature },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", left: "" } },
                                  [_vm._v("mdi-plus")]
                                ),
                                _vm._v(" Adicionar Assinante "),
                              ],
                              1
                            ),
                            _vm.hasAdditionalSignatures ||
                            _vm.localModel.manager_signer_enabled
                              ? _c(
                                  "div",
                                  [
                                    _c("v-switch", {
                                      staticClass: "mt-3",
                                      attrs: {
                                        inset: "",
                                        dense: "",
                                        "hide-details": "",
                                        label:
                                          "Assinatura sequencial (Docente → Gestor → demais assinantes)",
                                      },
                                      model: {
                                        value:
                                          _vm.localModel.sequential_signing,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.localModel,
                                            "sequential_signing",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "localModel.sequential_signing",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "caption grey--text mt-1",
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { "x-small": "" } },
                                          [_vm._v("mdi-information-outline")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.localModel.sequential_signing
                                                ? "Cada assinante só recebe o link e pode assinar depois que o anterior assinar."
                                                : "Todos os assinantes recebem o link ao mesmo tempo e assinam em paralelo."
                                            ) +
                                            " O documento é considerado assinado ao final de todas as assinaturas. "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        !_vm.isPit
                          ? [
                              _c(
                                "span",
                                {
                                  class: {
                                    "error--text": !!_vm.errors.content,
                                  },
                                },
                                [_vm._v("Conteúdo*")]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    "editor-error": !!_vm.errors.content,
                                  },
                                },
                                [
                                  _c("vue-editor", {
                                    ref: "editor",
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    on: {
                                      "selection-change": function ($event) {
                                        _vm.range = $event
                                      },
                                    },
                                    model: {
                                      value: _vm.localModel.content,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.localModel, "content", $$v)
                                      },
                                      expression: "localModel.content",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.errors.content
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-messages error--text mt-1",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "v-messages__message" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              Array.isArray(_vm.errors.content)
                                                ? _vm.errors.content[0]
                                                : _vm.errors.content
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _c(
                              "v-alert",
                              {
                                staticClass: "ma-0",
                                attrs: { type: "info", text: "", dense: "" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      small: "",
                                      left: "",
                                      color: "info",
                                    },
                                  },
                                  [_vm._v("mdi-flash")]
                                ),
                                _vm._v(
                                  " O conteúdo deste documento será gerado dinamicamente com base nos dados do Extrato do Professor. "
                                ),
                              ],
                              1
                            ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Obrigatório concordar para avançar no cadastro",
                            label: "Obrigatório",
                          },
                          model: {
                            value: _vm.localModel.is_required,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "is_required", $$v)
                            },
                            expression: "localModel.is_required",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.localModel.is_required
                      ? _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "4" } },
                          [
                            _c("s-switch", {
                              attrs: {
                                inset: "",
                                "text-helper":
                                  "Bloqueia o acesso ao Sistema até a assinatura",
                                label: "Bloquear acesso ao Sistema",
                              },
                              model: {
                                value: _vm.localModel.block_profile,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localModel, "block_profile", $$v)
                                },
                                expression: "localModel.block_profile",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Enviar e-mail para o usuário com cópia do termo",
                            label: "Enviar E-mail",
                          },
                          model: {
                            value: _vm.localModel.send_email,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "send_email", $$v)
                            },
                            expression: "localModel.send_email",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Salvar cópia do termo em PDF no Servidor",
                            label: "Salvar PDF",
                            disabled: _vm.isPit,
                          },
                          model: {
                            value: _vm.localModel.save_pdf,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "save_pdf", $$v)
                            },
                            expression: "localModel.save_pdf",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.localModel.save_pdf
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.signatureProviderItems,
                                "item-text": "text",
                                "item-value": "value",
                                label: "Provedor de Assinatura Digital",
                                hint: "Assinatura Digital para assinatura qualificada; Interna apenas aceita no sistema",
                                "persistent-hint": "",
                                outlined: "",
                                dense: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.localModel.signature_provider,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localModel,
                                    "signature_provider",
                                    $$v
                                  )
                                },
                                expression: "localModel.signature_provider",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.localModel.send_email
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("v-divider", { staticClass: "my-2" }),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "subtitle-2 grey--text text--darken-1",
                              },
                              [
                                _c(
                                  "v-icon",
                                  { staticClass: "mr-1", attrs: { small: "" } },
                                  [_vm._v("mdi-email-edit-outline")]
                                ),
                                _vm._v(
                                  " Configuração do E-mail de Comunicação "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.localModel.send_email
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Assunto do E-mail",
                                error: !!_vm.errors.email_subject,
                                "error-messages": _vm.errors.email_subject,
                                placeholder:
                                  "Ex: Termo de Aceite de Carga Horária",
                                "persistent-placeholder": "",
                                hint: "Assunto que aparecerá no e-mail enviado ao professor",
                                counter: 255,
                                rules: [
                                  (v) =>
                                    !v ||
                                    v.length <= 255 ||
                                    "Máximo de 255 caracteres atingido",
                                ],
                              },
                              model: {
                                value: _vm.localModel.email_subject,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localModel, "email_subject", $$v)
                                },
                                expression: "localModel.email_subject",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.localModel.send_email
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("span", { staticClass: "caption grey--text" }, [
                              _vm._v("Corpo do E-mail"),
                            ]),
                            _c("vue-editor", {
                              ref: "emailEditor",
                              attrs: {
                                editorToolbar: _vm.customToolbar,
                                placeholder:
                                  "Texto personalizado do e-mail. Tags disponíveis: [[NOME_PROFESSOR]], [[NOME_TERMO]], [[LINK_ASSINATURA]]",
                              },
                              model: {
                                value: _vm.localModel.email_body,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localModel, "email_body", $$v)
                                },
                                expression: "localModel.email_body",
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "caption grey--text" },
                              [
                                _vm._v(" Use o botão "),
                                _c("v-icon", { attrs: { "x-small": "" } }, [
                                  _vm._v("mdi-tag-plus-outline"),
                                ]),
                                _vm._v(
                                  " no cabeçalho ou Ctrl+Shift+T para inserir tags "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("v-switch", {
                          attrs: { color: "purple", inset: "", label: "Ativo" },
                          model: {
                            value: _vm.localModel.active,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "active", $$v)
                            },
                            expression: "localModel.active",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }